import { render, staticRenderFns } from "./FilterAtendimentos.vue?vue&type=template&id=0c4f825e"
import script from "./FilterAtendimentos.vue?vue&type=script&lang=js"
export * from "./FilterAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports